import React, { useEffect, useState } from 'react';
import { createClient } from '../../../prismicio';
import { PrismicRichText } from 'common/components/PrismicRichText/PrismicRichText';
import {
  LogoSection,
  LogoContainer,
  Title,
  LogoScroller,
  LogoItem,
} from './logo.style';
import Container from 'common/components/Container';

const SectionCustomerLogos = ({ slice }) => {
  const [logos, setLogos] = useState([]);

  useEffect(() => {
    const fetchLogos = async () => {
      const client = createClient();

      const logoPromises = slice.items.map(async (item) => {
        try {
          const logoDoc = await client.getByUID(
            'logos',
            item.content_logos.uid,
          );
          return logoDoc.data;
        } catch (error) {
          console.error('Error fetching logo:', error);
          return null;
        }
      });

      const logoData = await Promise.all(logoPromises);
      setLogos(logoData.filter(Boolean));
    };

    fetchLogos();
  }, [slice.items]);

  const duplicatedLogos = [...logos, ...logos];

  return (
    <LogoSection>
      <Container>
        <LogoContainer>
          <PrismicRichText
            field={slice.primary.title}
            components={{
              paragraph: ({ children }) => (
                <Title variant="h2">{children}</Title>
              ),
            }}
          />
          <LogoScroller>
            {duplicatedLogos.map((logo, index) => (
              <LogoItem key={index}>
                <img
                  src={logo?.image?.url}
                  alt={logo.image?.alt || 'Customer logo'}
                  style={{ width: 'auto', height: '60px' }}
                />
              </LogoItem>
            ))}
          </LogoScroller>
        </LogoContainer>
      </Container>
    </LogoSection>
  );
};

export default SectionCustomerLogos;
